import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditDialogService from "../../../../services/screens/admin/talkchinese/EditDialogService";
import { ActionTypes } from "../../../actionTypes/screens/admin/talkchinese/EditDialogActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.talkchinese.editdialog;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditDialogService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_ASYNC, vo });

            EditDialogService.save(
                vo,
                response => {
                    dispatch(Actions.saveSuccess(response));
                },
                error => {
                    dispatch(Actions.saveFailure(error));
                }
            );
        };
    },

    saveSuccess: data => ({
        type: ActionTypes.SAVE_SUCCESS,
        parentType: ActionTypes.SAVE_ASYNC,
        data
    }),

    saveFailure: error => ({
        type: ActionTypes.SAVE_FAILURE,
        parentType: ActionTypes.SAVE_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    units: [],
};

//
// Reducers
//
function removeUnit(units, u) {
    var i = units.indexOf(u);
    if (i >= 0) {
        units.splice(i, 1);
    }
}

function checkUnitsIntegrity(units) {
    if (units.length < 1) {
        return true;
    }

    let poka1 = units[units.length - 1];
    if (poka1.unitType !== "POKA1") {
        return false;
    }

    let tempData = {};
    for (let i = 0; i < units.length; ++i) {
        let u = units[i];
        if (u.unitType === "POKA4") {
            if (tempData.poka4) {
                if (!tempData.poka3) {
                    return false;
                }

                if (tempData.poka3.length < 1) {
                    return false;
                }
            }
            tempData = { poka4: u, poka3: [] }
        }
        else if (u.unitType === "POKA3") {
            if (!tempData.poka3) {
                return false;
            }
        }
    }
    return true;
}

function tryFixUnitsOrder(units) {
    if (checkUnitsIntegrity(units)) {
        return units;
    }

    let poka1 = units.find(u => u.unitType === 'POKA1');
    if (!poka1) {
        return units;
    }

    removeUnit(units, poka1);

    var result = [];
    var poka4s = [];
    units.forEach(u => {
        if (u.unitType === "POKA4") {
            if (u.data &&
                u.data.singleUnits && u.data.singleUnits[0] &&
                u.data.singleUnits[0].content &&
                u.data.singleUnits[0].content.chars &&
                (u.data.singleUnits[0].content.chars.join("").length > 0))
            {
                poka4s.push({keyword: u.data.singleUnits[0].content.chars.join(""), unit: u, poka3s: []});
            }
        }
    });

    poka4s.forEach(u => removeUnit(units, u.unit));
    let hasMore = true;
    while (hasMore) {
        hasMore = false;
        for (let i = 0; i < poka4s.length; ++i) {
            let keyword = poka4s[i].keyword;
            for (let j = 0; j < units.length; ++j) {
                let u = units[j];
                if (u.unitType === "POKA3") {
                    let content = u.data.singleUnits[0].content.chars.join("");
                    if (content.indexOf(keyword) >= 0) {
                        poka4s[i].poka3s.push(u);
                        removeUnit(units, u);
                        hasMore = true;
                        break;
                    }
                }
            }
        }
    }

    poka4s.forEach(u => {
        result.push(u.unit);
        u.poka3s.forEach(u3 => result.push(u3));
    });
    result.push(poka1);
    return result;
}

const loadScreenViewSuccessPostReducer = (state, { data }) => {
    let { units = [] } = data;
    units.forEach(u => u.data = JSON.parse(u.data));

    units = tryFixUnitsOrder(units);
    return { ...state, units };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
